window.__tnt || (window.__tnt = {});
window.__tnt.eedition || (__tnt.eedition = {});

/******************************************************************************
 * Initialize Events 
 */

/*
 * Page View
 * @event #BLOXEEditionPageViewed
 */
logEEditionPageViewed = new CustomEvent('BLOXEEditionPageViewed', { detail: {} });

/*
 * E-Edition Page Navigation Initiated
 * @event #BLOXEEditionPageNavigationInitiated
 */
logEEditionPageNavigationInitiated = new CustomEvent('BLOXEEditionPageNavigationInitiated', { detail: {} });

/*
 * E-Edition Segment Asset Viewed
 * @event #BLOXEEditionSegmentAssetView
 */
logEEditionSegmentAssetView = new CustomEvent('BLOXEEditionSegmentAssetView', { detail: {} });

/*
 * E-Edition Display Fit Selected
 * @event #BLOXEEditionDisplayFitSelected
 */
logEEditionDisplayFitSelected = new CustomEvent('BLOXEEditionDisplayFitSelected', { detail: {} });

/*
 * E-Edition Zoom Level Modified
 * @event #BLOXEEditionZoomLevelModified
 */
logEEditionZoomLevelModified = new CustomEvent('BLOXEEditionZoomLevelModified', { detail: {} });



/******************************************************************************
 * Event Emitting Functions 
 */

/*
 * logEEditionPageViewed
 * @fires #BLOXEEditionPageViewed
 */
 __tnt.eedition.logEEditionPageViewed = function(data){
     if(data){
        logEEditionPageViewed.detail.segmented = data.segmented;
        logEEditionPageViewed.detail.zoom_level = data.zoom_level;
        logEEditionPageViewed.detail.display_fit = data.display_fit;
    
        window.dispatchEvent(logEEditionPageViewed);
    }
 }
 
/*
 * logEEditionPageNavigationInitiated
 * @fires #BLOXEEditionPageNavigationInitiated
 */
 __tnt.eedition.logEEditionPageNavigationInitiated = function(data){
    if(data){
        logEEditionPageNavigationInitiated.detail.navigation_method = data.navigation_method;
        logEEditionPageNavigationInitiated.detail.navigation_subsection = data.navigation_subsection;
        
        window.dispatchEvent(logEEditionPageNavigationInitiated);
    }
 }
 
/*
 * logEEditionSegmentAssetView
 * @fires #BLOXEEditionSegmentAssetView
 */
 __tnt.eedition.logEEditionSegmentAssetView = function(data){
    if(data){
        logEEditionSegmentAssetView.detail.segment_asset_id = data.segment_asset_id;
        logEEditionSegmentAssetView.detail.segment_asset_name = data.segment_asset_name;
        logEEditionSegmentAssetView.detail.segment_asset_url = data.segment_asset_url;
        logEEditionSegmentAssetView.detail.segment_asset_page_number = data.segment_asset_page_number;
    
        window.dispatchEvent(logEEditionSegmentAssetView);
    }
 }
 
/*
 * logEEditionDisplayFitSelected
 * @fires #BLOXEEditionDisplayFitSelected
 */
 __tnt.eedition.logEEditionDisplayFitSelected = function(data){
    if(data){
        logEEditionDisplayFitSelected.detail.selected_fit = data.selected_fit;
        logEEditionDisplayFitSelected.detail.selected_num_of_pages = data.selected_num_of_pages;
        logEEditionDisplayFitSelected.detail.is_fullscreen = data.is_fullscreen;
        logEEditionDisplayFitSelected.detail.is_cover = data.is_cover;
    
        window.dispatchEvent(logEEditionDisplayFitSelected);
    }
 }
 
/*
 * logEEditionZoomLevelModified
 * @fires #BLOXEEditionZoomLevelModified
 */
 __tnt.eedition.logEEditionZoomLevelModified = function(data){
    if(data){
        logEEditionZoomLevelModified.detail.zoom_method = data.zoom_method;
        logEEditionZoomLevelModified.detail.zoom_level = data.zoom_level;
    
        window.dispatchEvent(logEEditionZoomLevelModified);
    }
 }